import {
  CurrentSectionItem,
  SectionsItem
} from 'components/Theme/StoreTheme/storeTheme.types';

import { Observable } from './observable';

class SectionsStateService {
  readonly editedSectionId = new Observable<string>('');
  readonly currentSection = new Observable<CurrentSectionItem | null>(null);
  readonly bundleSections = new Observable<SectionsItem[]>([]);
  readonly promotionSections = new Observable<SectionsItem[]>([]);

  clear = () => {
    this.editedSectionId.set('');
    this.currentSection.set(null);
    this.bundleSections.set([]);
    this.promotionSections.set([]);
  };

  setEditedSectionId = (id: string) => this.editedSectionId.set(id);
  setCurrentSection = (section: CurrentSectionItem | null) =>
    this.currentSection.set(section);
  setBundleSections = (sections: SectionsItem[]) =>
    this.bundleSections.set(sections);
  setPromotionSections = (sections: SectionsItem[]) =>
    this.promotionSections.set(sections);
}

export const sectionsStateService = new SectionsStateService();
